import { Injectable } from '@angular/core';

import type {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import type { Observable } from 'rxjs';
import { ConfigService } from '../services/config.service';

@Injectable({
  providedIn: 'root',
})
export class IsInIframeGuard implements CanActivate {
  constructor(private config: ConfigService, private window: Window) {}

  private iframeParentUrl = '/nutrition-calculator';

  private get isInIframe(): boolean {
    return this.window.self !== this.window.top;
  }

  private get shouldRedirect(): boolean {
    const {
      config: {
        environment: { redirectIfNotInIframe },
      },
      isInIframe,
    } = this;

    return redirectIfNotInIframe && !isInIframe;
  }

  private redirect(): void {
    this.window.location.href = this.iframeParentUrl;
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.shouldRedirect) {
      this.redirect();

      return false;
    }

    return true;
  }
}
